<template>
  <div class="dutyGoods_container">
    <div class="searh">
      <a-button type="primary" @click="replace" style="margin-right: 15px" :disabled="val.length < 1"
        >替换责任人</a-button
      >
      <!-- <a-tree-select allowClear :treeData="departList" placeholder="请选择部门"  v-model="duty.departId" style="width: 200px; margin-right: 10px;"
							 @change="selectDepartment" >
				</a-tree-select> -->

      <a-select
        allowClear
        placeholder="请选择资产类别"
        v-model="duty.assetTypeName"
        style="width: 200px; margin-right: 10px"
      >
        <a-select-option :value="item.dictCode" v-for="(item, index) in assetTypeList" :key="index">
          {{ item.dictLabel }}
        </a-select-option>
      </a-select>
      <!-- <a-select allowClear placeholder="请选择资产类别"  v-model="duty.assetTypeName" @change="getAssetTypeName" style="width: 200px; margin-right: 10px;">
                        <a-select-option :value="item.dictCode"  v-for="(item, index) in assetTypeList" :key="index" >
                            {{ item.dictLabel }}
                        </a-select-option>
				</a-select> -->
      <!-- @keyup.enter.native="" -->
      <a-input placeholder="物品名称" class="a_input_self margin_self" v-model="duty.name" />
      <a-button type="primary" @click="searchDutyGoods" style="margin-left: 15px">查询</a-button>
      <a-button type="primary" @click="resetDutyGoods">重置</a-button>
    </div>
    <div class="tables">
      <div id="content_main_center_scroll">
        <a-table
          :pagination="false"
          :scroll="{ x: 1500, y: 400 }"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          :columns="columns"
          :data-source="goodsList"
          rowKey="id"
        />
        <Pagination
          v-model="pagination.current"
          :total="pagination.total"
          show-size-changer
          :page-size="pagination.pageSize"
          @onShowSizeChange="onShowSizeChange"
        ></Pagination>
      </div>
    </div>
    <!-- 替换责任人弹窗 -->
    <Receive
      :replaceTypes="types"
      :replaceVisible="replaceVisible"
      @visibleState="visibleState"
      :val="val"
      @put="getNewList"
    ></Receive>
  </div>
</template>
<script>
// import Pagination from '@/components/pagination'
import Receive from '../components/rceive.vue'
import Pagination from '@/components/pagination/index.vue'
import { dutyAsset_list, replaceDuty_put, assetType_get } from '@/api/Industry'
import { tree_all } from '@/api/purchase'

export default {
  components: {
    Receive,
    Pagination,
  },
  props: ['rowData', 'userName'],
  data() {
    return {
      assetTypeList: [],
      // departList: {},
      duty: {},
      replaceVisible: false,
      val: [],
      selectedRowKeys: [],
      types: 0,
      goods: {
        loginName: '',
      },
      goodsList: {},
      columns: [
        {
          title: '所属部门',
          dataIndex: 'belongDept',
          ellipsis: true,
        },
        {
          title: '资产类别',
          dataIndex: 'assetTypeName',
          ellipsis: true,
        },
        {
          title: '物品编号',
          dataIndex: 'assetSn',
          ellipsis: true,
        },
        {
          title: '物品状态',
          dataIndex: 'goodStatus',
          ellipsis: true,
        },
        {
          title: '物品名称',
          dataIndex: 'name',
          ellipsis: true,
        },
        {
          title: '规格型号',
          dataIndex: 'model',
          ellipsis: true,
        },
        {
          title: '物品单价',
          dataIndex: 'singlePrice',
          ellipsis: true,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        itemName: '',
        hideOnSinglePage: false,
      },
      selectionRows: []
    }
  },
  created() {
    this.getDutyAsset_list()
    console.log(this.$route.query.row, 'this.$route.query.row=======================')
    // tree_all().then(res => {
    //     console.log(res, 'res')
    //     let companyList = res.data[0]
    //     console.log(companyList, 'companyList')
    //     let companyId = this.$store.state.user.info.companyId
    //     // if(!companyList) {
    //          companyList.forEach(item => {
    //         if( item.deptId == companyId) {
    //           this.departList = item.children
    //            this.departList.forEach(item3 => {
    //         item.value = item3.title
    //         item.title = item3.title
    //      if(item.children) {
    //         item3.children.forEach( item1 => {
    //         item1.value = item1.title
    //         item1.title = item1.title
    //          item1.children.forEach( item2 => {
    //         item2.value = item2.title
    //         item2.title = item2.title
    //      })
    //      })
    //   }
    //   return this.departList
    //            })

    //         }

    //     });

    //     })
    assetType_get({
      dictType: 'assets_type',
    }).then((res) => {
      this.assetTypeList = res

      console.log(JSON.parse(JSON.stringify(res)), 'res++++++++++++++++++++++++++++++')
    })
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() + 150
      }, 1000)
    })
  },
  methods: {
    // onSelect(record, selected, selectedRows, nativeEvent) {
    //         // console.log("单选选择")
    //         this.selectedRowKeys = selectedRows.map(pro => pro.id)
    //         console.log(this.selectedRowKeys, '1111111111111111111111111111')
    //     },
    //     onSelectAll(selected, selectedRows, changeRows) {
    //         // console.log("全选")
    //         if (selected) {
    //             // 全选
    //             this.selectedRowKeys = this.goodsList.map(pro => pro.id)
    //         } else {
    //             // 反选
    //             this.selectedRowKeys = []
    //         }
    //         console.log(this.selectedRowKeys, '222222222222222222222222222222')
    //     },






    getNewList() {
      this.getDutyAsset_list()
    },
    onShowSizeChange(current, pageSize) {
      console.log(current, pageSize)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      //改变完 重新渲染数据
      this.getDutyAsset_list()
    },
    getAssetTypeName() {},
    // selectDepartment(e) {
    //     this.duty.deptId = e
    // },
    visibleState(data) {
      this.replaceVisible = data.replaceVisible
      this.val = data.val

      this.selectedRowKeys = data.selectedRowKeys
      console.log(this.val, 'this.val==================')
    },
    onSelectChange(selectedRowKeys, val) {
      console.log(selectedRowKeys, val, 'val========================================')
      this.selectedRowKeys = selectedRowKeys
      this.val = val
    },
    //改变分页
    // handleTableChange(pagination, filters, sorter) {
    //     console.log(pagination,'pagination===============')
    // 	this.pagination= pagination
    // 	this.getDutyAsset_list()
    // },
    // 替换责任人
    replace() {
      this.replaceVisible = true
      this.types = 1
      // replaceDuty_put().then(res => {
      //     console.log(res, 'res=======================')
      // })
    },
    getDutyAsset_list() {
      this.goodsList = []
      dutyAsset_list({
        charger: this.userName,
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        deptId: this.duty.deptId,
        assetType: this.duty.assetTypeName,
        name: this.duty.name,
      }).then((res) => {
        this.goodsList = res.rows
        this.pagination.total = res.total
        dutyAsset_list({
          charger: this.userName,
          pageIndex: this.pagination.current,
          pageSize: this.pagination.pageSize,
        }).then((res) => {
          if (res.total == 0) {
            this.$emit('fisterTab', this.goodsList)
          }
        })

        console.log(this.userName, 'this.$route.query.row.userName=============================')
        console.log(this.goodsList, 'this.goodsList=============================')
      })
      //    pageNum: this.current,
      // 	   pageSize: this.pageSize,
      //    {
      //        deptId: this.$route.query.row.deptId,
      //    }
      //    dutyAsset_list().then(res => {
      //        console.log(res, 'res=============================')

      //    })
    },
    //    搜索列表
    searchDutyGoods() {
      console.log('111111111111111111111111111')
      this.loading = true
      this.pagination.current = 1
      this.getDutyAsset_list()
    },
    //    重置列表
    resetDutyGoods() {
      this.duty = {}
      this.getDutyAsset_list()
      // this.duty.deptId = ''
      // this.duty.deptId = ''
      // this.duty.assetTypeName = ''
      // this.duty.name = ''
    },
  },

  //获取责任物品信息
}
</script>
<style>
.dutyGoods_container {
  padding: 20px;
}
.dutyGoods_container .tables {
  margin-top: 20px;
}
.pages {
  margin-top: 20px;
}
</style>
